import axios from "axios";
import Apis from "../../constants/Api";
let Axios = axios.create({
  baseURL: Apis.baseUrl, //"https://backend.ayandehsazan.ir/"
});
Axios.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `token ${localStorage.getItem(
      "aghighToken"
    )}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default Axios;
